import { UserRoleType } from "@/constants/auth";
import type { CurrentUser } from "@/types/general";

const TRAINER_ROLE_SLUGS = new Set(["egitmen", "trainer", "instructor"]);

function normalizeRoleSlug(raw: string): string {
  return raw.trim().toLowerCase().replace(/_/g, "-");
}

function roleMatchesTrainer(slug: string | undefined): boolean {
  if (!slug?.trim()) return false;
  return TRAINER_ROLE_SLUGS.has(normalizeRoleSlug(slug));
}

/** Oturum eğitmen mi (JWT userType veya rol adı / roles[]) */
export function isTrainerSession(
  userType: number | null,
  user: CurrentUser | null,
): boolean {
  if (userType === UserRoleType.INSTRUCTOR) return true;
  if (roleMatchesTrainer(user?.role)) return true;
  const roles = user?.roles;
  if (Array.isArray(roles)) {
    return roles.some((r) => roleMatchesTrainer(r?.name));
  }
  return false;
}
